import callAsync from './callAsync';

/**
 * Creates a react-like ref that prohibits access to the actual element.
 */
export default function createAriaRef() {
	const subscriptionMap = new Map();
	const childAriaRefToPath = new WeakMap();
	let __current;
	let __parent;

	const ref = {
		isAriaRef: true,
		setCurrent(value) {
			__current = value;
			callAsync(() => {
				subscriptionMap.forEach(attributeToCallback => {
					for (const attribute in attributeToCallback) attributeToCallback[attribute](this);
				});
			});
		},
		setParentAriaRef(parentAriaRef) {
			__parent = parentAriaRef;
		},
		getParentAriaRef() {
			return __parent;
		},
		isSet() {
			return !!__current;
		},
		setId(id) {
			__current.id = id;
		},
		getAttribute(name) {
			return __current.getAttribute(name);
		},
		getRootNode() {
			return __current.getRootNode();
		},
		cloneNode(deep) {
			return __current.cloneNode(deep);
		},
		setChildQuerySelector(childAriaRef, path) {
			childAriaRefToPath.set(childAriaRef, path);
		},
		getChildQuerySelector(childAriaRef) {
			return childAriaRefToPath.get(childAriaRef);
		},
		contains(node) {
			if (__current) return __current.contains(node);

			return false;
		},
		subscribe({element, attribute}, cb) {
			let attributeToCallback = subscriptionMap.get(element);
			if (attributeToCallback) {
				const oldCb = attributeToCallback[attribute];
				if (oldCb) oldCb(null);
			} else {
				attributeToCallback = {};
				subscriptionMap.set(element, attributeToCallback);
			}

			attributeToCallback[attribute] = cb;
			cb(this);
		},
		unsubscribe({element, attribute}) {
			const attributeToCallback = subscriptionMap.get(element);
			if (attributeToCallback) {
				const cb = attributeToCallback[attribute];

				if (cb) cb(null);

				delete attributeToCallback[attribute];
				if (Object.keys(attributeToCallback).length === 0) subscriptionMap.delete(element);
			}
		}
	};

	Object.seal(ref);

	return ref;
}
